<template>
    <div class="frame" :class="style" @touchmove="touches_move" @touchend="touches_end">
        <div class="hotNews_outWrap">
            <div class="hotNews_wrap" :style="{ fontSize: s_count.size + 0.8 + 'rem' }">
                <!-- <div class="new_title">
					<div class="new_title_back e_back" @touchstart="$emit('back')"></div>
					<div class="new_title_content">螺纹相关</div>
					<div class="new_title_font" @touchstart="s_count.change_size = !s_count.change_size">Aa</div>
				</div> -->

                <transition name="fade">
                    <div v-if="s_count.change_size" class="s_wrap">
                        <div class="s_content">
                            <div class="s_tag_first">Aa字号设置：小</div>
                            <div class="s_box" ref="s_box" @touchstart="touches_start($event)">
                                <div class="s_bottom"></div>
                                <div class="s_top" ref="s_top" :style="{right: s_count.right + 'px'}">
                                    <div class="s_circle" ref="s_circle"></div>
                                </div>
                            </div>
                            <div class="s_tag_last">大</div>
                        </div>
                    </div>
                </transition>



                <div class="new_scorll" style="top:0;" v-if="ready_flag">
                    <div class="new_banner">
                        <div class="new_box">
                            <img src="../../public/img/icons/android-chrome-192x192.png" alt="">
                            <h2>随身行</h2>
                            <span>掌上的期货生活</span>
                        </div>
                        <div class="button" @click="to_ssx">{{ '马上' + (is_wx ? (is_ios&&app_version('6.8')? '打开': '下载') : '打开') }}</div>
                    </div>
                    <div class="new_content">
                        <div class="new_content_img" v-if="imgsrc !== ''">
                            <img :src="imgsrc" alt="">
                            <!-- <div style="background: url('../assets/images/SourceIcon/day/4@3x.png')  no-repeat left/contain;"></div> -->
                        </div>
                        <div class="new_content_articles" @touchstart="s_count.change_size = false">
                            <div class="new_content_title">{{ echoValue.title }}</div>
                            <div class="new_content_time">{{ change_date }}</div>
                            <div class="new_content_body">
                                <div ref="target">
                                    <div v-html="target">

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="new_footer">注：本页内容未经核实，据此入市风险自负</div>

                    <div class="new_content_comments clearfix" :style="{padding: '0 1.5rem 0 1.5rem'}"
                        v-if="comments_section && comment_list && comment_list.length > 0">
                        <div class="news_comment">
                            最新评论
                        </div>
                        <div class="user_comment">
                            <p v-if="!comments_section">评论区关闭</p>
                            <div class="h_say" v-else v-for="(item , index) in comment_list" :key="index">
                                <div class="h_sayDetail_user clearfix">
                                    <div class="h_sayDetail_head e_photo_link">
                                        <img :src="item.UserInfo.FacePath | head" alt="">
                                    </div>
                                    <div class="h_say_user_txt">
                                        <div class="h_say_name">
                                            <a class="e_name_link">{{ item.UserInfo.NickName }}</a>
                                        </div>
                                        
                                    </div>
                                    <div class="h_say_bottomWrap position-right" style="border:none;">
                                        <div class=" h_say_bottomBtn e_like e_auth"
                                            :class="item.Gooded ? ' w_say_liked' : ''" @click="item_like(index)">
                                            <div class="h_say_bottomBtn_like h_say_bottomBtn_txt d_like_num">
                                                {{ item.GoodCount || '赞' }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="h_say_commentContent select-content">{{ item.Body }}</div>
                                <div class="h_sayDetail_repost select-content">
                                            {{ item.Timeline | decorateTime(nowtime)}} 
                                        </div>
                            </div>
                        </div>
                        <!-- <div class="new_footBox">
							<input v-model="message" placeholder="我说几句..." type="text" class="new_submit_box e_new_callSubmit h_button">
							<div id="new_more" 
								class="new_more h_button"
								@click="submit_comment"
							>
								<i class="icon iconfont icon-message_fill" style="font-size: 2.2rem; vertical-align: middle;"></i>
							</div>
							<div 
								class="new_share h_button"
								@click="share_comment">
								<i class="icon iconfont icon-share_fill" style="font-size: 2.2rem; vertical-align: middle;"></i>
							</div>
						</div> -->

                    </div>
                    
                    <div class="more_comment" @click="to_newDetail_ssx" v-if="comments_section && comment_list && comment_list.length > 0">更多评论</div>
                </div>
                
                
            </div>
        </div>
        <Loading v-if="Loading_flag" v-on:remove="Loading_flag = false" />
        <GuestPop v-if="guestpop_flag" v-on:remove="guestpop_flag = false" />
        <AlertPop v-if="alertpop_flag" :alertpop_text="alertpop_text" />
        <div v-show="guideShow" @click="guideShow = false" class="guide_pop"></div>
    </div>
</template>
<script>
    import wh from '../assets/js/global.js'
    import $ from "jquery";
    import Loading from "@/components/Loading.vue";
    import GuestPop from "@/components/GuestPop.vue";
    import AlertPop from "@/components/AlertPop.vue";

    let post_block = false,
        WeiboID = null;

    var timer;
    var u = navigator.userAgent;
    var is_android = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Miui') > -1 || u.indexOf(
        'XiaoMi') > -1; //android终端
    var is_ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var is_wx = u.match(/(MicroMessenger)/i) || u.match(/QQ/i);

    function init(_call, url,encryption_newid) {

        function change() {
            _call && _call();
            timer && clearTimeout(timer);
            timer = null;
        }

        function bind(event_name) {
            document.removeEventListener(event_name, change);
            document.addEventListener(event_name, change);
        }

        bind('visibilitychange');
        bind('webkitvisibilitychange');

        var newid= encryption_newid!=undefined?encryption_newid:'';
        
        if (is_wx) {
            _call && _call();
            var iosUrl = wh.app_version('6.8')? 'https://app.wenhua.com.cn/universal_links.html?data='+newid:'https://apps.apple.com/cn/app/wen-hua-cai-jing-sui-shen-xing/id464184960';
            location.href = is_ios ? iosUrl :
                'https://m.wenhua.com.cn/?os=android';
            return
        }

        timer = setTimeout(function () {
            _call && _call();
            location.href = is_ios ?
                'https://app.wenhua.com.cn/universal_links.html?data='+newid :
                'https://m.wenhua.com.cn/?os=android';
        }, 3500);
        // load('sms://');
        load(url);

    }

    function load(url) {
        if (is_ios) {
            location.href = url;
        } else {
            var page = document.createElement('iframe');
            page.setAttribute('src', url);
            page.setAttribute('style', 'width:0; height:0; position: absolute; left: 0; top: 0; border: 0;');
            document.body.appendChild(page);

            setTimeout(function () {
                document.body.removeChild(page);
            }, 200);
        }

    }

    function bind(event_name) {
        document.addEventListener(event_name, function () {
            timer && clearTimeout(timer);
            timer = null;
        });
    }

    bind('visibilitychange');
    bind('webkitvisibilitychange');

    let protoprefix = 'wenhua'
    if (is_android) {
        protoprefix = 'webstock'
    }
    if (is_ios) {
        protoprefix = 'wenhua'
    }
    export default {
        name: 'HotNews',
        components: {
            GuestPop,
            Loading,
            AlertPop
        },
        data() {
            return {
                theme: 'white',
                echoValue: {
                    id: Number,
                    title: '',
                    date: '',
                    content: '',
                    token: Number,
                    source: Number,
                    comment: false,
                    info: Number
                },
                comment_list: [],
                s_count: {
                    right: 0,
                    size: 1,
                    change_size: false,
                    touch_flag: false
                },
                nowtime: String,
                target: null,
                comments_section: false,
                guestpop_flag: false,
                alertpop_flag: false,
                Loading_flag: false,
                ready_flag: false,
                alertpop_text: '',
                message: '',
                is_wx,
                guideShow: false,
                is_ios:is_ios,
                app_version:wh.app_version
            }
        },
        computed: {
            imgsrc() {
                if (wh.imgSrc.is_exist(this.echoValue.source)) {
                    const src = this.theme == 'black' ? wh.imgSrc.night[this.echoValue.source] :
                        wh.imgSrc.day[this.echoValue.source];
                    return src;
                }
                return '';
            },
            style() {
                return 'hotNews_' + this.theme;
            },
            face_path() {
                return wh.has_auth()
            },
            change_date() {
                if (this.echoValue.date) {
                    var data = this.echoValue.date.split("T");
                    return data[0] + ' ' + data[1].split(":")[0] + ':' + data[1].split(":")[1];
                }
                return '';
            }
        },
        filters: {
            cont(item) {
                return
            }
        },
        created() {
            const that = this;
            // this.$axios.get('/mock/content.json'
            // ).then(that.newscontent).catch(function (error) {
            // 	console.log(error)
            // })

            this.$axios.post('/api/NewsInteract/NewsDetail', {
                link: that.$route.params.newsid
            }).then((res) => {
                if (res.data.status) {
                    that.newscontent({
                        data: {
                            id: res.data.ResultData.Weibo.ID,
                            title: res.data.ResultData.Weibo.Subject,
                            date: res.data.ResultData.Weibo.DateAndTime,
                            content: res.data.ResultData.Weibo.Body,
                            theme: 'black',
                            token: 0,
                            source: 9000,
                            comment: true,
                            info: 0
                        },
                        commentList: res.data.ResultData.Weibo.CommentList,
                        nowtime: res.data.nowtime
                    })
                } else {
                    // 数据传入标记
                    this.ready_flag = true;
                    this.echoValue.title = res.data.Message;
                }
            }).catch(function (error) {
                console.log(error)
            })

            that.set_size(0.3);

            // wh.bridge({
            // 	class: 'NewsContentWebPlugin',
            // 	method: 'getFontSize'
            // }, "getFontSize", that.set_size);
        },
        mounted() {

        },
        methods: {
            newscontent(res) {

                if (res) {

                    this.echoValue = res.data || res;

                    const echoValue = this.echoValue;

                    // 数据传入标记
                    this.ready_flag = true;

                    this.target = echoValue.content;

                    this.plList(res.commentList, res.nowtime);

                    this.$nextTick(() => {
                        var $target = $(this.$refs.target);

                        // $target.find('a').click(function () {
                        // 	var url = $(this).attr('href');
                        // 	wh.bridge({
                        // 		class: 'InteractiveBasePlugin',
                        // 		method: 'browse',
                        // 		callback: (res)=>{
                        // 			alert('链接点击交互回调啦')
                        // 		},
                        // 		param: {
                        // 			url: url,
                        // 			horizontal: false
                        // 		}
                        // 	});
                        // 	return false;
                        // });

                        var list = [];
                        $target.find('img').each(function (index) {
                            var $self = $(this);
                            $self.css('width', '100%');
                            // list.push($self.attr('src'));
                            // $self.click(function () {
                            // 	wh.bridge({
                            // 		class: 'ImagePlugin',
                            // 		method: 'view',
                            // 		callback:function (echoValue) {
                            // 			alert('新闻内容图片交互回调啦')
                            // 		},
                            // 		param: {
                            // 			current: index,
                            // 			list: list
                            // 		}
                            // 	});
                            // });
                        });
                        $target.find('table').each(function (index) {
                            var $self = $(this);
                            $self.css('width', '100%');
                        });
                        $target.find('*').css('font', '');
                    })
                }
            },
            to_ssx() {
                    // init(_ => {
                    //     this.Loading_flag = false;
                    // }, protoprefix + '://shared/news?newsid=' + this.$route.params.newsid);
                    // this.Loading_flag = true;
                if((u.match(/QQ/i)|| u.match(/WeiBo/i))&&is_ios){
                    this.guideShow = true
                    return 
                }

                this.$axios.post('/api/NewsInteract/GetEncryption',{
                    "module": "news",
                    "params": {
                        "id": this.$route.params.newsid
                    },
                    "symbol": "wenhua"
                }).then((res) => {
                    init(_ => {
                        this.Loading_flag = false;
                    }, protoprefix + '://bridge/?data=' + res.data.ResultData,res.data.ResultData);
                    this.Loading_flag = true;
                }).catch(function (error) {
                    console.log(error)
                })
            },
            to_newDetail_ssx() {
                if (is_wx) {
                    this.guideShow = true
                } else {
                    this.$axios.post('/api/NewsInteract/GetEncryption',{
                        "module": "news",
                        "params": {
                            "id": this.$route.params.newsid
                        },
                        "symbol": "wenhua"
                    }).then((res) => {
                        init(_ => {
                            this.Loading_flag = false;
                        }, protoprefix + '://bridge/?data=' + res.data.ResultData,res.data.ResultData);
                        this.Loading_flag = true;
                    }).catch(function (error) {
                        console.log(error)
                    })
                    
                }

            },
            plList(_comment_list, _nowtime) {
                const that = this;
                if (!this.echoValue.comment) {
                    return;
                }
                if (!_comment_list || !_comment_list.List) return;
                // let sortList = _comment_list.List.sort((a,b)=>b.GoodCount - a.GoodCount)
                let isHuaWei = this.$route.query.isHuaWei == 1
                that.comment_list = isHuaWei ? [] : _comment_list.List.sort((a, b) => b.GoodCount - a.GoodCount).splice(0,
                2); //取评论数最多的两个评论显示
                that.nowtime = _nowtime;

                // 显示评论区   阿古需求 分享页不显示评论
                that.comments_section = true;
            },
            n_alert(_text) {
                this.alertpop_text = _text;
                this.alertpop_flag = true;
                wh.delayed(() => {
                    this.alertpop_flag = false;
                }, 2000);
            },
            item_like(index) {

                // if (!wh.has_auth()) {
                // 	this.guestpop_flag = true;
                // 	return false;
                // }

                // 禁止点赞

                // let gooded = this.comment_list[index].Gooded,
                // 	good_count = this.comment_list[index].GoodCount;

                // this.comment_list[index].Gooded = !gooded;

                // if (this.comment_list[index].Gooded) {
                // 	this.n_alert('已赞');
                // 	if(good_count > 0) {
                // 		this.comment_list[index].GoodCount += 1;
                // 	}else {
                // 		this.comment_list[index].GoodCount = 1;
                // 	}
                // } else {
                // 	this.n_alert('已取消赞');
                // 	if(good_count > 0) {
                // 		this.comment_list[index].GoodCount -= 1;
                // 	}else {
                // 		this.comment_list[index].GoodCount = 0;
                // 	}
                // }
                return false;
            },
            submit_comment() {

                // if (!this.islogin) {
                // 	this.guestpop_flag = true;
                // 	return false;
                // }

                // if(typeof this.message == 'string' && $.trim(this.message) !== '' ) {
                // 	if(!post_block) {
                // 		post_block = true;
                // 		const that = this;
                // 		this.axios.get('/api/comment/Post',{
                // 			id: WeiboID,
                // 			ReplyID: 0,
                // 			Forward: false,
                // 			IsCircle: 0,
                // 			Body: this.message
                // 		}
                // 		).then((_result)=>{
                // 			_result = _result.data;
                // 			wh.cache.clean();
                // 			if (_result.status) {
                // 				that.n_alert('提交成功');
                // 			} else {
                // 				that.n_alert(_result.Message);
                // 			}
                // 		}).catch(()=>{

                // 		})
                // 	}else {
                // 		this.n_alert('提交太频繁！');
                // 	}
                // }else {
                // 	this.n_alert('提交内容不能为空！');
                // }
            },
            set_size(_size) {

                this.s_count.size = _size;

            },
            touch_common(e) {
                var width = this.$refs.s_box.offsetWidth;
                var circle_width = this.$refs.s_circle.offsetWidth;
                var x = e.touches[0].clientX;

                var gross = width - x + this.$refs.s_box.offsetLeft,
                    new_size = Math.floor((x - this.$refs.s_box.offsetLeft) / width * 10) / 10;
                if (gross < 0) {
                    this.s_count.right = 0;
                } else if (gross < width - circle_width) {
                    this.s_count.right = gross;
                } else {
                    this.s_count.right = width - circle_width;
                }
                wh.delayed(() => {
                    if (gross < 0) {
                        this.s_count.size = new_size > 1 ? 1 : new_size;
                    } else if (gross < width - circle_width) {
                        this.s_count.size = new_size < 0.1 ? 0.1 : new_size;
                    } else {
                        this.s_count.size = new_size < 0.1 ? 0.1 : new_size;
                    }
                }, 300);

            },
            touches_start(e) {
                this.touch_common(e);
                this.s_count.touch_flag = true;
            },
            touches_move(e) {
                if (this.s_count.touch_flag) {
                    this.touch_common(e);
                }
            },
            touches_end() {
                if (this.s_count.touch_flag) {
                    this.s_count.touch_flag = false;
                }
            }
        },
        watch: {
            's_count.change_size'(val) {
                if (val) {
                    this.$nextTick(() => {
                        var width = this.$refs.s_box.offsetWidth;
                        this.s_count.right = width - width * this.s_count.size;
                    })
                }
            }
        }
    }
</script>

<style scoped>
    @import "../assets/css/hotNews.css";
    @import "../assets/font/iconfont.css";

    .fade-enter-active,
    .fade-leave-active {
        transition: transform .3s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
        {
        transform: translateY(-3rem);
    }
</style>